import { render, staticRenderFns } from "./addDeploy.vue?vue&type=template&id=2f622e51&scoped=true&"
import script from "./addDeploy.vue?vue&type=script&lang=js&"
export * from "./addDeploy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f622e51",
  null
  
)

export default component.exports